import { render, staticRenderFns } from "./Needs.vue?vue&type=template&id=63217c7f&scoped=true"
import script from "./Needs.vue?vue&type=script&lang=js"
export * from "./Needs.vue?vue&type=script&lang=js"
import style0 from "./Needs.vue?vue&type=style&index=0&id=63217c7f&prod&scoped=true&lang=css"
import style1 from "@/assets/Needs.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63217c7f",
  null
  
)

export default component.exports